import { FieldFooter } from '@lichtblick/photon/atoms/field-footer';
import classNames from 'classnames';
import type { FC, PropsWithChildren } from 'react';

import styles from './media-card-slider.module.scss';

export type MediaCardSliderProps = PropsWithChildren<{
  desktopColumns: 2 | 3;
  errorMessage?: string;
}>;

/**
 * MediaCardSlider contain a list of MediaCards and handle the grid alignment. On mobile the cards are horziontally scrollable.
 */
export const MediaCardSlider: FC<MediaCardSliderProps> = ({ children, desktopColumns, errorMessage }) => (
  <div className={styles.wrapper}>
    <div className={classNames(styles.slider, styles[`slider-columns-${desktopColumns}`])}>{children}</div>
    {Boolean(errorMessage) && (
      <FieldFooter className={styles['error-message']} data-testid="field-error" error>
        {errorMessage}
      </FieldFooter>
    )}
  </div>
);
